/* lp-range-picker — <lp-range-picker> in swap mode: select an option → LP.emit('product-change', {handle}) and
   scroll to the buy box. Also follows lp:product-change from elsewhere so the selected state stays in sync. */
(function () {
  'use strict';
  if (window.customElements.get('lp-range-picker')) return;
  class LpRangePicker extends HTMLElement {
    connectedCallback() {
      if (this.dataset.mode !== 'swap_buy_box') return;
      var self = this;
      this.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-lp-select]'); if (!btn) return;
        var handle = btn.dataset.lpSelect;
        self.mark(handle);
        if (window.LP) {
          window.LP.emit('product-change', { handle: handle, source: 'lp-range-picker' });
          var box = window.LP.resolveTarget('product'); if (box) window.LP.scrollTo(box);
        }
      });
      if (window.LP) this.off = window.LP.on('product-change', function (e) { if (e.detail && e.detail.source !== 'lp-range-picker') self.mark(e.detail.handle); });
    }
    disconnectedCallback() { if (this.off) this.off(); }
    mark(handle) {
      Array.prototype.forEach.call(this.querySelectorAll('.lp-range-picker__option'), function (o) {
        var on = o.dataset.handle === handle;
        o.classList.toggle('is-selected', on);
        var b = o.querySelector('[data-lp-select]'); if (b) b.setAttribute('aria-pressed', on);
      });
    }
  }
  window.customElements.define('lp-range-picker', LpRangePicker);
})();
